import React, { Component } from "react";

import Winners from "./Winners";

import Logo from "../Components/Logo";

import { Parallax } from "react-parallax";
import ModelSpecs from "./ModelSpecs";
import Video from "./Video";

export default class Content extends Component {
  constructor(props) {
    super(props);
    this.state = {
      readMore: false,
    };
    this.winCar = React.createRef();

    this.handleToggleClick = this.handleToggleClick.bind(this);
  }

  componentDidMount() {
    //console.log(this.winCar.current.offsetTop)
  }

  handleToggleClick(e) {
    const currentButton = "content-" + e.target.dataset.contentid;
    this.setState((prevState) => ({
      [currentButton]: !prevState[currentButton],
    }));
  }

  triggerModal(type = "rules") {
    this.props.modal(type);
  }

  toggleReadMore = () => {
    this.setState((prevState) => ({
      readMore: !prevState.readMore,
    }));
  };

  render() {
    const { language, winners } = this.props;
    return (
      <div className="content--wrapper" ref={this.winCar}>
        <div className="content--inside" id="campaign">
          <div className="content--full content--header">
            {language === "et" ? (
              <p className="slogan text--align__center goldenText">
                Mängides lotot püsitellimusega, püsid mängus ka siis, kui oled
                ise unustanud õnnele võimaluse anda.
              </p>
            ) : (
              <>
                <p className="slogan text--align__center goldenText">
                Играя в лотерею по подписке, вы остаетесь в игре даже тогда, когда сами забыли дать удаче шанс.
                </p>
              </>
            )}
          </div>

          <div className="content--full">
            {language === "et" ? (
              <>
                <p>
                Kõik <strong>7.&nbsp;oktoobrist kuni 3.&nbsp;novembrini</strong> püsitellimusega ostetud lotopiletid osalevad LISALOOSIS, kus loosime iga nädal välja <strong>5×100 €</strong>.
                  
                </p>
              </>
            ) : (
              <>
                <p>
                

Если оформите подписку на покупку лотерейных билетов в период <strong>с&nbsp;7&nbsp;октября по 3&nbsp;ноября</strong>, то все игровые комбинации, купленные по вашей подписке, примут участие в дополнительном розыгрыше, где каждую неделю разыгрывается <strong>5×100 €</strong>.
                </p>
              </>
            )}
          </div>
          <div className="content--full content--primary">
            {language === "et" ? (
              <>
                <h3>Mis on püsitellimus</h3>
                <p>
                  Püsitellimus on mugav viis lasta süsteemil osta Sulle
                  lotopilet automaatselt. Nii ei unusta sa piletit osta, kui
                  tegelikult tahaksid lotomängus osaleda. Püsitellimuse saad
                  vormistada{" "}
                  <a
                    href="https://www.eestiloto.ee/et/bingoloto/?utm_source=campaignpage&utm_medium=text&utm_campaign=pysitellimus&utm_term=bingoloto"
                    target="_blank"
                  >
                    Bingo loto
                  </a>
                  ,{" "}
                  <a
                    href="https://www.eestiloto.ee/et/vikinglotto/?utm_source=campaignpage&utm_medium=text&utm_campaign=pysitellimus&utm_term=vikinglotto"
                    target="_blank"
                  >
                    Vikinglotto
                  </a>
                  ,{" "}
                  <a
                    href="https://www.eestiloto.ee/et/eurojackpot/?utm_source=campaignpage&utm_medium=text&utm_campaign=pysitellimus&utm_term=eurojackpot"
                    target="_blank"
                  >
                    Eurojackpoti
                  </a>
                  ,{" "}
                  <a
                    href="https://www.eestiloto.ee/et/keno/?utm_source=campaignpage&utm_medium=text&utm_campaign=pysitellimus&utm_term=keno"
                    target="_blank"
                  >
                    Keno
                  </a>{" "}
                  või{" "}
                  <a
                    href="https://www.eestiloto.ee/et/jokker/?utm_source=campaignpage&utm_medium=text&utm_campaign=pysitellimus&utm_term=jokker"
                    target="_blank"
                  >
                    Jokkeri
                  </a>{" "}
                  piletite ostuks vastava mängu ostulehel.
                </p>
                <span
                  className="readMore"
                  onClick={() => this.toggleReadMore()}
                >
                  {this.state.readMore ? "Näita vähem" : "Loe edasi"}
                </span>
              </>
            ) : (
              <>
                <h3>Что Такое Подписка</h3>
                <p>
                Подписка — это удобный способ позволить системе автоматически покупать для вас лотерейные билеты. Благлдяря подписке вы не забудете о покупке билета, если хотите всегда  участвовать в лотерее. Подписку можно оформить для покупки билетов
                  <a
                    href="https://www.eestiloto.ee/ru/bingoloto/?utm_source=campaignpage&utm_medium=text&utm_campaign=pysitellimus&utm_term=bingoloto"
                    target="_blank"
                  >
                    {" "}Bingo loto
                  </a>
                  ,{" "}
                  <a
                    href="https://www.eestiloto.ee/ru/vikinglotto/?utm_source=campaignpage&utm_medium=text&utm_campaign=pysitellimus&utm_term=vikinglotto"
                    target="_blank"
                  >
                    Vikinglotto
                  </a>
                  ,{" "}
                  <a
                    href="https://www.eestiloto.ee/ru/eurojackpot/?utm_source=campaignpage&utm_medium=text&utm_campaign=pysitellimus&utm_term=eurojackpot"
                    target="_blank"
                  >
                    Eurojackpot
                  </a>
                  ,{" "}
                  <a
                    href="https://www.eestiloto.ee/ru/keno/?utm_source=campaignpage&utm_medium=text&utm_campaign=pysitellimus&utm_term=keno"
                    target="_blank"
                  >
                    Keno
                  </a>{" "}
                  или {" "}
                  <a
                    href="https://www.eestiloto.ee/ru/jokker/?utm_source=campaignpage&utm_medium=text&utm_campaign=pysitellimus&utm_term=jokker"
                    target="_blank"
                  >
                    Jokker
                  </a>{" "}
                  на соответствующей странице игры. 
                </p>
                <span
                  className="readMore"
                  onClick={() => this.toggleReadMore()}
                >
                  {this.state.readMore ? "Читать далее" : "Читать далее"}
                </span>
              </>
            )}
          </div>
        
          <div
            className={`content--full ${
              this.state.readMore ? "content--active" : "content--notActive"
            }`}
          >
            {language === "et" ? (
              <>
                <h3>Püsitellimuse vormistamine</h3>
                <p>
                  Püsitellimust vormistades ostetakse esimene pilet koheselt
                  ning edaspidi ostetakse pilet uuele loosimisele öösel kell 2
                  pärast eelmise loosimise toimumist. Pileti eest tasud
                  igakordsel ostul. Püsitellimust vormistades teed valiku,
                  kuidas püsitellimuse eest tasud: e-rahakotis olevate
                  vahenditega või mängukontoga seotud maksekaardiga.
                </p>
                Vormistades püsitellimuse, saad valida, kas pilet ostetakse
                <ul>
                  <li>kõigile loosimistele, või </li>
                  <li>ainult suure <i>jackpotiga</i> loosimistele, või</li>
                  <li>
                    vaid konkreetse nädalapäeva loosimisele (juhul, kui valitud
                    mängu loosimised toimuvad mitu korda nädalas).
                  </li>
                </ul>
                <p>
                  Saad valida ka, kas soovid piletit oma numbritega või tahad,
                  et numbrid oleks igal loosimisel uued (pliks-plaks).
                </p>
                <p>
                  Saad püsitellimuse iga hetk peatada või kustutada. Juhul kui
                  su mängukontol/maksekaardil puudub pileti eest tasumiseks
                  raha, siis peatab süsteem ise püsitellimuse ja kui soovid
                  püsitellimusega jätkata, pead selle taas aktiveerima.
                  {/*  Kuidas teha püsitellimust (see võib valmida hiljem) */}
                  <br />
                  <br />
                  Tutvu ka püsitellimuse{" "}
                  <a href="https://www.eestiloto.ee/et/account/subscriptionterms">
                    tingimustega{" "}
                  </a>
                </p>
              </>
            ) : (
              <>
              <h3>Оформление подписки</h3>
              <p>
              При оформлении подписки первый билет покупается сразу, а в дальнейшем билет на новый розыгрыш будет покупаться в 2 часа ночи после проведения предыдущего розыгрыша. Оплата за билет будет происходить при каждой покупке. Оформляя подписку, вы выбираете, как будете оплачивать подписку: средствами из э-кошелька или платёжной картой, привязанной к игровому аккаунту.
              </p>
              Оформляя подписку, можете выбрать будет ли билет покупаться 
              <ul>
              <li>на все розыгрыши, или</li>
            	<li>только на розыгрыши с большим джекпотом, или</li>
            	<li>только на розыгрыш в конкретный день недели (в случае, если розыгрыши выбранной игры проводятся несколько раз в неделю).</li>

              </ul>
              <p>
              Также можно выбрать, желаете ли билет со своими собственными номерами или предпочтёте, чтобы номера каждый раз были новыми (пликс-плакс).
              </p>
              <p>
              Вы можете в любой момент приостановить или удалить подписку. В случае, если на вашем игровом аккаунте/платёжной карте недостаточно средств для оплаты билета, система автоматически приостановит подписку, и если вы захотитеь продолжить, нужно будет её заново активировать.
                {/*  Kuidas teha püsitellimust (see võib valmida hiljem) */}
                <br />
                <br />
                
                <a href="https://www.eestiloto.ee/ru/account/subscriptionterms">
                Ознакомтесь с условиями подписки
                </a>
              </p>
            </>
            )}
          </div>
          <div
            className={`content--full content--howToPlay`} >
            {language === "ru" ? (<>
            <div className="howToPlay"><span><span className="howToPlay--number">1.</span>Войдите в систему </span><img src="./assets/images/1_ru.jpg"/></div>
            <div className="howToPlay"><span><span className="howToPlay--number">2.</span>Выберите номера самостоятельно или с помощью «пликс-плакс» </span><img src="./assets/images/2_ru.jpg"/></div>
            <div className="howToPlay"><span><span className="howToPlay--number">3.</span>Включите подписку</span><img src="./assets/images/3_ru.jpg"/></div>
            <div className="howToPlay"><span><span className="howToPlay--number">4.</span>Нажмите на кнопку подписки</span><img src="./assets/images/4_ru.jpg"/></div>
            <div className="howToPlay"><span><span className="howToPlay--number">5.</span>Выберите способ оплаты и просмотрите другие варианты </span><img src="./assets/images/5_ru.jpg"/></div>
            <div className="howToPlay"><span><span className="howToPlay--number">6.</span>Оформите заказ </span><img src="./assets/images/6_ru.jpg"/></div>
            </>):(
              <>
            <div className="howToPlay"><span><span className="howToPlay--number">1.</span>Logi sisse</span><img src="./assets/images/1.jpg"/></div>
            <div className="howToPlay"><span><span className="howToPlay--number">2.</span>Vali numbrid ise või pliks-plaksiga</span><img src="./assets/images/2.jpg"/></div>
            <div className="howToPlay"><span><span className="howToPlay--number">3.</span>Lülita sisse püsitellimus</span><img src="./assets/images/3.jpg"/></div>
            <div className="howToPlay"><span><span className="howToPlay--number">4.</span>Vajuta püsitellimuse nupule</span><img src="./assets/images/4.jpg"/></div>
            <div className="howToPlay"><span><span className="howToPlay--number">5.</span>Vali makseviis ja vaata üle muud valikud</span><img src="./assets/images/5.jpg"/></div>
            <div className="howToPlay"><span><span className="howToPlay--number">6.</span>Vormista tellimus</span><img src="./assets/images/6.jpg"/></div>
            </>

            )}
            </div>
          <div className="content--full content--primary">
            {language === "et" ? (
              <>
                <h3>Lisaloosis osalemine</h3>
                <p>
                  Lisaloosid toimuvad neljal esmaspäeval kõigi loosimisele
                  eelneval nädalal püsitellimusega ostetud piletite vahel. Iga
                  pilet osaleb lisaloosis nii mitme võiduvõimalusega, kui palju
                  on piletil mängukombinatsioone. Lisaloosimistes osalevad nii
                  äsja vormistatud kui varasemast kehtivad püsitellimused, mille
                  alusel on vastaval nädalalal ostetud pilet.{" "}
                </p>
              </>
            ) : (
              <>
                <h3>Участие в дополнительном розыгрыше</h3>
                <p>
                Дополнительные розыгрыши проводятся в течение четырёх понедельников подряд среди всех билетов, купленных по подписке на предыдущей неделе перед розыгрышем. Каждый билет участвует в дополнительном розыгрыше с таким количеством выигрышных возможностей, сколько на нём игровых комбинаций. В дополнительных розыгрышах участвуют как недавно оформленные, так и ранее действующие подписки, по которым на соответствующей неделе был куплен билет.
                </p></>
            )}
          </div>

          <Winners language={language} winners={winners} />

          <Logo src="assets/images/EL_blue.svg" alt="Eesti Loto" />

          <p className="disclaimer">
            {language === "et"
              ? `Tähelepanu! Tegemist on hasartmängu reklaamiga. Hasartmäng pole
            sobiv viis rahaliste probleemide lahendamiseks. Tutvuge reeglitega
            ja käituge vastutustundlikult!`
              : `Внимание! Вы имеете дело с рекламой азартной игры. Азартные игры не являются средством решения материальных проблем. Ознакомьтесь с правилами и поступайте ответственно!`}
          </p>
        </div>
      </div>
    );
  }
}
